import { bp as cn, bq as R, bY as dn, br as pn, bu as t, bt as e } from "./helpers-458d7e27.js";
import { useMemo as un } from "react";
import { CloseIcon as yn, InformationIcon as vn, CheckmarkBackgroundIcon as gn, WarningIcon as bn, CriticalIcon as mn } from "@paypalcorp/pp-react-icons";
import { useTheme as Cn, jsx as M, css as s } from "@emotion/react";
import "react/jsx-runtime";
import "clsx";
import "@paypalcorp/pp-react-theme";
import "react-dom";
var N, F, $, V, X, q, U, Y, D, G;
function Sn(n) {
  if (!Object.keys(n).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var u = n.sysSpaceXs, d = n.sysSpaceSm, L = n.sysSpaceMd, l = n.sysSpaceLg, i = n.sysSizeFieldSm, y = n.sysSizeIconSm, T = n.sysTypographyBodySize, r = n.sysBorderThicknessNormal, S = n.sysBorderRadiusLg, f = n.sysColorSystemMain, j = n.sysColorSystemMainActive, h = n.sysColorSelectedContrast, B = n.sysColorStructureFocus, a = n.sysColorInfoMain, v = n.sysColorInfoContrast, A = n.sysColorSuccessMain, p = n.sysColorSuccessContrast, g = n.sysColorWarningMain, b = n.sysColorWarningContrast, O = n.sysColorErrorMain, m = n.sysColorErrorContrast, H = pn(n), J = H.body, K = t("".concat(u, " * 2")), W = t(" ".concat(K, " + ").concat(i)), x = t("".concat(l, " + ").concat(T, " + ").concat(L)), Q = t("".concat(l, " - ").concat(r)), Z = t("".concat(l, " - ").concat(r)), w = t("".concat(l, " - ").concat(r)), z = t("".concat(l, "- ").concat(r)), k = t("".concat(d, " - ").concat(r)), E = t("".concat(d, " - ").concat(r)), nn = t("".concat(l, "- ").concat(r)), on = s(N || (N = e([`
    label: alert_base;
    box-sizing: border-box;
    padding: `, " ", " ", `
      `, `;
    border-width: `, `;
    border-style: solid;
    border-radius: `, `;
    position: relative;
    text-align: initial;
    `, `;

    [dir='rtl'] & {
      padding-left: `, `;
      padding-right: `, `;

      &:before {
        left: auto;
        right: `, `;
      }
    }
  `])), Q, W, Z, x, r, S, J({
    color: f
  }), W, x, z), rn = s(F || (F = e([`
    label: svg_icon;
    display: inline-block;
    position: absolute;
    left: `, `;
    text-align: center;
    color: `, `;
    line-height: `, `;
    font-size: `, `;
    top: `, `;
    vertical-align: middle;

    [dir='rtl'] & {
      left: auto;
      right: `, `;
    }
  `])), z, j, y, y, nn, z), an = s($ || ($ = e([`
    label: close_btn;
    position: absolute;
    top: `, `;
    right: `, `;
    color: `, `;

    &:focus {
      background-color: `, `;
      &:after {
        border-color: `, `;
      }
    }

    &:hover {
      background-color: `, `;
    }

    [dir='rtl'] & {
      left: `, `;
      right: auto;
    }
  `])), k, E, v, h, B, h, E), I = function(o, c) {
    return s(V || (V = e([`
      border: none;
      background-color: `, `;
      color: `, `;
    `])), o, c);
  }, tn = function(o) {
    var c = {
      info: I(a, v),
      warning: I(g, b),
      success: I(A, p),
      error: I(O, m)
    };
    return s(X || (X = e([`
      label: `, `;
      `, `;
    `])), o, c[o]);
  }, P = function(o) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : f, C = s(q || (q = e([`
      color: `, `;
      &:hover,
      &:focus {
        color: `, `;
      }
    `])), o, c);
    return C;
  }, en = function(o) {
    var c = {
      success: P(p),
      error: P(m),
      warning: P(b)
    }, C = "".concat(o, "_close_btn");
    return s(U || (U = e([`
      label: `, `;
      `, `;
    `])), C, c[o]);
  }, _ = function(o) {
    return s(Y || (Y = e([`
      color: `, `;
    `])), o);
  }, sn = function(o) {
    var c = {
      info: _(v),
      warning: _(b),
      success: _(p),
      error: _(m)
    }, C = "".concat(o, "_icon");
    return s(D || (D = e([`
      label: `, `;
      `, `;
    `])), C, c[o]);
  }, ln = s(G || (G = e([`
    label: no_close_btn;
    padding-right: `, `;
    [dir='rtl'] & {
      padding-left: `, `;
      padding-right: `, `;
    }
  `])), w, w, x);
  return {
    base: on,
    svgIcon: rn,
    closeBtn: an,
    noCloseBtn: ln,
    alertType: tn,
    alertCloseBtn: en,
    alertIcon: sn
  };
}
var fn = ["className", "type", "typeIconAriaLabel", "closeButton", "closeButtonLabel", "children"], hn = {
  info: vn,
  success: gn,
  warning: bn,
  error: mn
}, On = function(n) {
  var u, d, L = n.className, l = n.type, i = l === void 0 ? "info" : l, y = n.typeIconAriaLabel, T = y === void 0 ? i : y, r = n.closeButton, S = n.closeButtonLabel, f = S === void 0 ? "close alert" : S, j = n.children, h = cn(n, fn), B = Cn(), a = un(function() {
    return Sn(B);
  }, [B]), v = hn[i], A = [a.base, (u = a.alertType) === null || u === void 0 ? void 0 : u.call(a, i), !r && a.noCloseBtn], p;
  if (r) {
    var g, b = R({}, r), O = [a.closeBtn, (g = a.alertCloseBtn) === null || g === void 0 ? void 0 : g.call(a, i)];
    p = r && M("span", {
      "data-ppui": "true"
    }, M(dn, R({
      css: O,
      buttonType: "tertiary",
      size: "sm",
      svgIconComponent: yn
    }, b, {
      "data-ppui": "true"
    }), f));
  }
  var m = [a.svgIcon, (d = a.alertIcon) === null || d === void 0 ? void 0 : d.call(a, i)];
  return M("div", R({
    role: "alert",
    css: A,
    className: L,
    "data-ppui-info": "alert_3.1.21"
  }, h), M(v, {
    size: "sm",
    css: m,
    role: "img",
    "aria-label": T,
    "data-ppui": "true"
  }), j, p);
};
export {
  On as PpReactAlert
};
//# sourceMappingURL=PpReactAlert.js.map
